import { render } from "./TenantLayout.vue?vue&type=template&id=1183598a&scoped=true"
import script from "./TenantLayout.vue?vue&type=script&lang=js"
export * from "./TenantLayout.vue?vue&type=script&lang=js"

import "./TenantLayout.vue?vue&type=style&index=0&id=1183598a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1183598a"]])

export default __exports__